import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getDiagnosisList } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";
const UseFetchDiagnosisList = (page, pageSize, type) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["getDiagnosisList", page, pageSize, type],
        queryFn: () => getDiagnosisList(page, pageSize, type),
        enabled: !!page || !!pageSize || !!type,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UseFetchDiagnosisList;
